import { render, staticRenderFns } from "./Game_CoinProduct.vue?vue&type=template&id=435de7e9&scoped=true&"
import script from "./Game_CoinProduct.vue?vue&type=script&lang=js&"
export * from "./Game_CoinProduct.vue?vue&type=script&lang=js&"
import style0 from "./Game_CoinProduct.vue?vue&type=style&index=0&id=435de7e9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "435de7e9",
  null
  
)

export default component.exports